import React from 'react';
import { Flex, Spacer, Text, Spinner, Field } from '@oliasoft-open-source/react-ui-library';
import './style.css';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

export const PageCard = ({
  title = '',
  mainValue = '',
  secondaryValue = '',
  isLoading = false,
  tooltip = '',
  testId = '',
}) => {
  const testIdPrefix = testId ? `${testId}-page-card` : 'page-card';
  const mainValueTestId = `${testIdPrefix}-main-value-${convertToKebabCase(title)}`;

  return (
    <div className="page-card">
      <Flex direction="column" alignItems="center">
        <Spacer />
        <div className="page-card-title">
          <Field label={title} helpText={tooltip} />
        </div>
        <Text center>
          {isLoading ? (
            <Spinner dark />
          ) : (
            <div className="page-card-main-text" data-testid={mainValueTestId}>
              {mainValue}
            </div>
          )}
        </Text>
        <Text center faint>
          {secondaryValue}
        </Text>
      </Flex>
    </div>
  );
};
